import { useLocalSearchParams } from 'expo-router'

import FosterNotesCard from '@/components/fosters/cards/FosterNotesCard'
import FosterProfileCard from '@/components/fosters/cards/FosterProfileCard'
import { useFosterFormContext } from '@/components/fosters/FosterFormContext'
import FosterTab from '@/components/fosters/FosterTab'
import useFosterOwner from '@/hooks/useFosterOwner'
import { useAppStore } from '@/store/useAppStore'

const FosterInfoTab = () => {
  const { id: fosterId } = useLocalSearchParams<{ id: string }>()
  const { control, formState } = useFosterFormContext()
  const isFosterOwner = useFosterOwner(fosterId)

  const currentOrganization = useAppStore.use.currentOrganization().organization
  const isDisabled = !currentOrganization?.subscriptionActive || !isFosterOwner

  return (
    <FosterTab fosterId={fosterId} viewId="foster-info-tab">
      <FosterProfileCard
        control={control}
        disabled={isDisabled}
        formState={formState}
        fosterId={fosterId}
      />
      <FosterNotesCard
        control={control}
        disabled={isDisabled}
        formState={formState}
        fosterId={fosterId}
      />
    </FosterTab>
  )
}

export default FosterInfoTab
